import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import FetchPosts from "../Helpers/fetchPosts";
import { useGlobalState } from "../contexts/GlobalStateContext";

const Search = () => {
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const [searchParams, setSearchParams] = useSearchParams();
  const query = searchParams.get("query") || ""; // Default to empty string if 'query' is not present
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedSubcategory, setSelectedSubcategory] = useState("");
  const { globalState } = useGlobalState();

  // Fetch categories on mount
  useEffect(() => {
    fetch(`${baseUrl}/php/fetch_categories.php`)
      .then((response) => response.json())
      .then((data) => setCategories(data.categories))
      .catch((error) => console.error("Error fetching categories:", error));
  }, []);

  // Fetch subcategories when a category is selected
  useEffect(() => {
    if (selectedCategory) {
      fetch(`${baseUrl}/php/fetch_categories.php?category_id=${selectedCategory}`)
        .then((response) => response.json())
        .then((data) => setSubcategories(data.subcategories))
        .catch((error) => console.error("Error fetching subcategories:", error));
    } else {
      setSubcategories([]);
    }
  }, [selectedCategory]);

  const handleCategoryChange = (e) => {
    const newCategory = e.target.value;
    setSelectedCategory(newCategory);
    setSelectedSubcategory(""); // Reset subcategory selection
  };

  const handleSubcategoryChange = (e) => {
    setSelectedSubcategory(e.target.value);
  };

  return (
    <>
      {!globalState.fullScreenPost && (
        <div id="categories">
          <div className="dropdown-container">
            {/* Category Dropdown */}
            <select className="fullTextbox" value={selectedCategory} onChange={handleCategoryChange}>
              <option value="">Select Category</option>
              {categories.map((category) => (
                <option key={category.category_id} value={category.category_id}>
                  {category.category_name}
                </option>
              ))}
            </select>

            {/* Subcategory Dropdown */}
            <select
              className="fullTextbox"
              value={selectedSubcategory}
              onChange={handleSubcategoryChange}
              disabled={!selectedCategory}
            >
              <option value="">Select Subcategory</option>
              {subcategories.map((subcategory) => (
                <option key={subcategory.category_id} value={subcategory.category_id}>
                  {subcategory.category_name}
                </option>
              ))}
            </select>
          </div>
        </div>
      )}
      <div>
        {!globalState.fullScreenPost && query && selectedCategory ? (
          <h2>Filtered Results for "{query}"</h2>
        ) : !globalState.fullScreenPost && query ? (
          <h2>Search Results for "{query}"</h2>
        ) : null}
      </div>


      {/* Pass the 'query' parameter to FetchPosts */}
      <FetchPosts
        key={`${selectedCategory}-${selectedSubcategory}-${query}`}
        categoryID={selectedCategory}
        subcategoryID={selectedSubcategory}
        searchQuery={query}
      />
    </>
  );
};

export default Search;
